export var Grade;
(function (Grade) {
    Grade["KINDERGARTEN"] = "KINDERGARTEN";
    Grade["PRE"] = "PRE-K";
    Grade["FIRST"] = "1";
    Grade["SECOND"] = "2";
    Grade["THIRD"] = "3";
    Grade["FOURTH"] = "4";
    Grade["FIFTH"] = "5";
    Grade["MULTI"] = "MULTI";
    Grade["OTHER"] = "OTHER";
})(Grade || (Grade = {}));
export var FeedbackGrade;
(function (FeedbackGrade) {
    FeedbackGrade["A"] = "A";
    FeedbackGrade["B"] = "B";
    FeedbackGrade["C"] = "C";
})(FeedbackGrade || (FeedbackGrade = {}));
//# sourceMappingURL=grade.js.map